import React from 'react'
import { LuFileText } from 'react-icons/lu'

interface Props {
  title: React.ReactNode
  icon?: React.ReactNode
  children: React.ReactNode
}

const QuestionSection: React.FC<Props> = ({ title, icon, children }) => {
  return (
    <section>
      <header className="flex items-start gap-2 mb-2">
        <div
          className="size-6 rounded-md bg-primary/10 flex items-center
            justify-center text-primary -mt-0.5"
        >
          {icon || <LuFileText />}
        </div>
        <h3 className="font-semibold">{title}</h3>
      </header>
      {children}
    </section>
  )
}

export default QuestionSection
